const Images = {
    logo: "/images/brand/logo_alt.png",
    simmarket_logo: "/images/brand/simfinance_logo.png",
    simmarket_colored: "/images/brand/simmarket_colored.png",
    simcollect_logo: "/images/brand/simcollect_logo.png",
    simverify_logo: "/images/brand/simverify_logo.png",
    hero: "/images/hero/ecosystem.png",
    aboutLandscape: "/images/about/landscape.png",
    aboutConsumer: "/images/about/consumer.png",
    aboutInstitution: "/images/about/institution.png",
    aboutFintech: "/images/about/fintech.png",
    solutionMarket: "/images/solutions/simmarket_alt.png",
    solutionVerify: "/images/solutions/simverify_alt.png",
    solutionCollect: "/images/solutions/simcollect_alt.png",
    chooseSimple: "/images/choose/simple.png",
    chooseTransparent: "/images/choose/transparent.png",
    chooseTrusted: "/images/choose/trusted.png",
    chooseConnected: "/images/choose/connected.png",
    chooseIntelligent: "/images/choose/intelligent.png",
    choosePlatform: "/images/choose/platform.png",
    storyPoster: "/images/story/poster.png",
    partnerVisual: "/images/partner/visual.png",
    aboutPageHero: "/images/about-page/hero.png",
    aboutPageWho: "/images/about-page/who.png",
    aboutPageCeo: "/images/about-page/ceo.png",
    aboutTeam1: "/images/about-page/team-01.png",
    aboutTeam2: "/images/about-page/team-02.png",
    aboutTeam3: "/images/about-page/team-03.png",
    aboutTeam4: "/images/about-page/team-04.png",
    simmarketsHero: "/images/simmarkets/hero.png",
    simmarketsIntro: "/images/simmarkets/intro.png",
    simmarketsVideo: "/images/simmarkets/video.png",
    partnerEcobank: "/images/partner_logos/ecobank.png",
    partnerEnterprise: "/images/partner_logos/enterprise.png",
    partnerGcb: "/images/partner_logos/gcb_bank.png",
    partnerGlico: "/images/partner_logos/glico_group.png",
    partnerHollard: "/images/partner_logos/hollard-group.png",
    partnerSic: "/images/partner_logos/sic_group.png",
    partnerStanbic: "/images/partner_logos/stanbic.png",
    partnerZenith: "/images/partner_logos/zenith_bank.png",
    education: "/images/simmarkets/education.png",
    ai_recommendation: "/images/simmarkets/ai_recommendation.png",
    compare_illustrator: "/images/simmarkets/compare_illustrator.png",
    booking: "/images/simmarkets/booking.png",
    leads: "/images/simmarkets/leads.png",
    ccass: "/images/simmarkets/ccass.png",
    rewards: "/images/simmarkets/rewards.png",
    collectHero: "/images/simcollect/hero.png",
    collectIntro: "/images/simcollect/intro.png",
    collectVideo: "/images/simcollect/video.png",
    collectBenefitInstitutions: "/images/simcollect/benefit-institutions.png",
    collectBenefitTeams: "/images/simcollect/benefit-teams.png",
    collectBenefitCustomers: "/images/simcollect/benefit-customers.png",
    collectBenefitExecutives: "/images/simcollect/benefit-executives.png",
    collectBenefitRegulators: "/images/simcollect/benefit-regulators.png",
    verifyHero: "/images/simverify/hero.png",
    verifyIntro: "/images/simverify/intro.png",
    verifyVideo: "/images/simverify/video.png",
    verifyEngineVehicle: "/images/simverify/engine-vehicle.png",
    verifyEngineDevice: "/images/simverify/engine-device.png",
    verifyEngineSim: "/images/simverify/engine-sim.png",
    verifyEngineTrust: "/images/simverify/engine-trust.png",
};

export default Images;